import { useEffect, useState } from "react";

export const useScreenBreakpoint = () => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const screens = {
        sm: "0px",
        lg: "1280px",
        xl: "1440px",
        "2xl": "1700px",
        "2.5xl": "1800px",
        "3xl": "1900px",
    };
    let isDesktopXXL, isDesktopXL, isDesktop, isDesktopSM, isLaptopXL, isLaptop;
    if (width < +screens["lg"].replace("px", "")) {
        isLaptop = true;
    } else if (width < +screens["xl"].replace("px", "")) {
        isLaptopXL = true;
    } else if (width < +screens["2xl"].replace("px", "")) {
        isDesktopSM = true;
    } else if (width < +screens["2.5xl"].replace("px", "")) {
        isDesktop = true;
    } else if (width < +screens["3xl"].replace("px", "")) {
        isDesktopXL = true;
    } else if (width >= +screens["3xl"].replace("px", "")) {
        isDesktopXXL = true;
    }

    return {
        isLaptop,
        isLaptopXL,
        isDesktopSM,
        isDesktop,
        isDesktopXL,
        isDesktopXXL,
        isSmallScreen: isLaptop || isLaptopXL || isDesktopSM,
    };
};
